import React from 'react';
import { Dump } from '~/utils';
import { useConfig } from '~/hooks';
import { Container, Row, Col } from 'reactstrap';

export function SystemInfo( props ) {
  const config = useConfig();

  return (
    <Container fluid>
      <Row>
        <Col>
          <h1>Configuration</h1>
          <Dump data={config.data} />
        </Col>
      </Row>
    </Container>
  );
}
